export const showBottomBarPathSet = new Set([
  "/overview",
  "/plans",
  "/plans/calorie-budget",
  "/plans/my-plan",
  "/plans/meal-preferences",
  "/plans/saved-meals",
  "/profile",
  "/settings-and-tools",
]);
